import { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";

const Header = () => {
  const { i18n } = useTranslation();

  const handleLanguageChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const nextLang = e.target.value;
    i18n.changeLanguage(nextLang);
  };

  return (
    <header className="flex justify-end items-center p-3 bg-gray-100">
      <select id="lang-select" value={i18n.language} onChange={handleLanguageChange} className="border rounded p-1 bg-white">
        <option value="ko">한국어</option>
        <option value="en">English</option>
        <option value="ja">日本語</option>
        <option value="zh">中文</option>
      </select>
    </header>
  );
};

export default Header;
